import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const FontWeight = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 20 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4.47637 2.58386C3.95723 2.58386 3.53638 3.00471 3.53638 3.52385C3.53638 4.043 3.95723 4.46385 4.47637 4.46385H9.25066V16.4762C9.25066 16.9954 9.67151 17.4162 10.1907 17.4162C10.7098 17.4162 11.1306 16.9954 11.1306 16.4762V4.46385H15.524C16.0431 4.46385 16.464 4.043 16.464 3.52385C16.464 3.00471 16.0431 2.58386 15.524 2.58386H10.1907H4.47637ZM4.7123 7.60519C5.07939 7.97228 5.07939 8.56745 4.7123 8.93454L2.9057 10.7411L4.7123 12.5477C5.07939 12.9148 5.07939 13.51 4.7123 13.8771C4.34521 14.2442 3.75003 14.2442 3.38294 13.8771L0.911673 11.4058C0.544582 11.0387 0.544582 10.4435 0.911673 10.0765L3.38294 7.60519C3.75003 7.2381 4.34521 7.2381 4.7123 7.60519ZM15.2522 7.60519C14.8851 7.97228 14.8851 8.56745 15.2522 8.93454L17.0588 10.7411L15.2522 12.5477C14.8851 12.9148 14.8851 13.51 15.2522 13.8771C15.6193 14.2442 16.2145 14.2442 16.5815 13.8771L19.0528 11.4058C19.4199 11.0387 19.4199 10.4435 19.0528 10.0765L16.5815 7.60519C16.2145 7.2381 15.6193 7.2381 15.2522 7.60519Z"
          fill={color}
        />
      </svg>
    )
  },
)

export default FontWeight
